import { createI18n } from 'vue-i18n';
import { zh } from '@/locales/zh/zh';
import { en } from '@/locales/en/en';
import { tr } from '@/locales/tr/tr';

const DEFAULT_LOCALE = 'en';



const i18n = createI18n({
  fallbackLocale: DEFAULT_LOCALE,
  globalInjection: true,
  legacy: false,
  messages: {
    zh,
    en,
    tr
  },
  locale: DEFAULT_LOCALE
});

export default i18n;

export function setI18nLocale(locale: string) {
  i18n.global.locale.value =
    locale as typeof i18n.global.availableLocales[number];
}

export const t = i18n.global.t;
export const tm = i18n.global.tm;

export function getCurrentLocale() {
  return i18n.global.locale.value;
}
